// extracted by mini-css-extract-plugin
export default {"container":"NoApplicationSelected_container__BdN5B"};